export { default } from './FeaturedGallery';
